import styled from "styled-components";

export const DarkText = styled.span`
  color: ${p => p.theme.colors.sharkAlt};
  font-weight: 700;
  margin: 0 2px;
`;

export const LightText = styled.span`
  color: ${p => p.theme.colors.sharkLighter};
  font-weight: 700;
  margin: 0 2px;
`;

export const Image = styled.img`
  margin: 0 15px 0 0;
`;

export const Header = styled.div`
  align-items: center;
  background: #eee;
  border-radius: 2px;
  display: flex;
  padding: 20px 15px;
`;
